export const AUTH_AUTHENTICATED = 'AUTH_AUTHENTICATED'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
